import store from '../store'
import { ykDateFormat } from '@/public/utils/globalFunc.js'
// import AXIOS from './index'

export default function writeSystemLog(response) {
  const URL = response.config.url
  const REQ_METHOD = response.config.method
  const REQ = response.config
  const RES = response.data
  const USER_NAME = `${store.state.userInfo.userName}${
    store.state.ipAndAddress.ip !== '' ? `(${store.state.ipAndAddress.ip} ${store.state.ipAndAddress.address})` : ''
  }`
  let str = ''
  // 如果请求失败了则跳出方法
  if (!RES.isSuccess) {
    return null
  }

  if (URL === '/login' && REQ_METHOD === 'post') {
    // 登录
    str = `${RES.data.userName}${
      store.state.ipAndAddress.ip !== '' ? `(${store.state.ipAndAddress.ip} ${store.state.ipAndAddress.address})` : ''
    } 登陆了`
  } else if (URL === '/Common/YKCase/sign' && REQ_METHOD === 'post') {
    // 签名问题
    const BODY = JSON.parse(REQ.data)
    str = USER_NAME + ' 签名了问题 ' + BODY.QUESTION_NUM_LIST.join(',')
  } else if (URL === '/Common/YKCase/cancelsign' && REQ_METHOD === 'post') {
    // 取消签名
    const BODY = JSON.parse(REQ.data)
    str = USER_NAME + ' 撤销了问题 ' + BODY.QUESTION_NUM_LIST.join(',') + ' 的签名'
  } else if (
    ['/Common/YKIssuedFlow/company-confirm', '/Common/YKIssuedFlow/company-review'].includes(URL) &&
    REQ_METHOD === 'put'
  ) {
    // 下发流程 按厂 签名
    const BODY = JSON.parse(REQ.data)
    const issuedFlowNum = REQ.headers.issuedFlowNum
    const GroupStrObj = {}
    BODY.forEach(item => {
      if (!['Sort', 'CheckItem'].includes(item.company)) {
        // 杜绝全选的情况
        GroupStrObj[item.company]
          ? GroupStrObj[item.company].push(item.sort)
          : (GroupStrObj[item.company] = [item.sort])
      }
    })
    let GroupStrList = Object.keys(GroupStrObj).map(key => {
      return '[ ' + key + ' 序号: ' + GroupStrObj[key].join(',') + ' ]'
    })
    str = USER_NAME + ' 签名了下发流程' + issuedFlowNum + '的CheckList(按厂): ' + GroupStrList.join(', ')
  } else if (
    ['/Common/YKIssuedFlow/checklist-confirm', '/Common/YKIssuedFlow/checklist-review'].includes(URL) &&
    REQ_METHOD === 'put'
  ) {
    // 下发流程 通用 签名
    const BODY = JSON.parse(REQ.data)
    str = USER_NAME + ' 签名了下发流程' + BODY.issuedFlowNum + '的CheckList(通用)序号: ' + BODY.sortList.join(',')
  } else if (String(URL).includes('/Common/YKIssuedFlow/issued/') && REQ_METHOD === 'put') {
    // 下发流程 确认下发
    const BODY = JSON.parse(REQ.data)
    str = USER_NAME + ' 确认下发了流程 ' + BODY.issuedFlowNum
  } else if (URL === '/Common/YKIssuedFlow/both' && REQ_METHOD === 'post') {
    // 新增下发流程
    const BODY = JSON.parse(REQ.data)
    str = `${USER_NAME} 新增了下发流程 ${BODY.subject}`
  } else if (URL === '/Common/YKIssuedFlow' && REQ_METHOD === 'delete') {
    // 删除下发流程
    const BODY = JSON.parse(REQ.data)
    str = `${USER_NAME} 删除了下发流程 ${BODY.issuedFlowNum}`
  } else if (URL === '/Common/DPBugs/both' && REQ_METHOD === 'post') {
    // 新增数据处理
    const BODY = JSON.parse(REQ.data)
    str = `${USER_NAME} 新增了数据处理 ${BODY.title}`
  } else if (URL === '/Common/DPBugs' && REQ_METHOD === 'delete') {
    // 删除数据处理
    const BODY = JSON.parse(REQ.data)
    str = `${USER_NAME} 删除了数据处理 ${BODY.BugTitle}`
  } else if (URL === '/Common/DPBugs/operate' && REQ_METHOD === 'post') {
    // 数据处理操作
    const BODY = JSON.parse(REQ.data)
    switch (BODY.action) {
      case '指派':
        str = `${USER_NAME} 将数据处理 [${BODY.bugTitle}] 指派给 ${BODY.extra}`
        break
      default:
        str = `${USER_NAME} 将数据处理 [${BODY.bugTitle}] ${BODY.action}`
        break
    }
  } else if (URL === '/Common/YKCase/addcomment' && REQ_METHOD === 'post') {
    const BODY = JSON.parse(REQ.data)
    switch (BODY.type) {
      case '说明':
        str = `${USER_NAME} 在 [${BODY.numList.join('、')}] 增加了说明`
        break
      case '解决':
      case '不处理':
      case '关闭':
      case '通过':
      case '激活':
        str = `${USER_NAME} 在 [${BODY.numList.join('、')}] 增加了${BODY.type}说明`
        break
      case '驳回':
        str = `${USER_NAME} ${BODY.type}了问题 [${BODY.numList.join('、')}]`
        break
    }
  }

  if (str) {
    return {
      actor: URL === '/login' ? RES.data.userName : store.state.userInfo.userName,
      action: '系统日志',
      actionTime: ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date()),
      comment: str
    }
    // await AXIOS.post('/Common/BActionLog/insert', {
    //   actor: URL === '/login' ? RES.data.userName : store.state.userInfo.userName,
    //   action: '系统日志',
    //   actionTime: ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date()),
    //   comment: str
    // })
  }
  return null
}
